module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAGNJREFUOBFjvHv37lYGBgYvBiDjP5DBwAhjgDgQgC7CBJOA0Vj0wKSIp9FtQdeJYSv1FRDyxzZ0K1H4IA/QwZF0sAKeGFD8RySHqGAgZBZBT44aQCgEGBhYgEq2EcpWeIzZCgC5+ym8f3vfhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-login-2018/tickle_default.png
// module id = 718
// module chunks = 1